<circ-loader [isLoading]="loading">
</circ-loader>
<circ-meta-basic
    *ngIf="!loading"
    [template]="template"
    (save)="onSave($event)"
    (abort)="onAbort()"
    ></circ-meta-basic>
